import { inject, Injectable } from '@angular/core';
import { EnumService } from '@backoffice-frontend/shared/bo/util-masterdata';
import { MarketDashboard } from '@clean-code/models';
import type { EnumValue, ID } from '@clean-code/models/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import type { Observable } from 'rxjs';
import { MarketColumnDataService } from './column.data.service';

@Injectable({
  providedIn: 'root',
})
export class MarketDashboardDataService {
  private graphqlService = inject(GraphqlService);
  private enumService = inject(EnumService);
  public static readonly entityName = 'marketDashboard';
  public static readonly dashboardGetParams = `
        id
        name
        cols
        {
            ${MarketColumnDataService.columnGetParams}
        }
    `;

  public timeFrames$(): Observable<EnumValue[]> {
    return this.enumService.getEnumType$('TimeFrame');
  }

  getAll$(): Observable<MarketDashboard[]> {
    const query = `
            query{
                ${MarketDashboardDataService.entityName}GetAll {
                    id
                    name
                }
            }`;

    return this.graphqlService.query<MarketDashboard[]>(query);
  }

  getByName$(name: string): Observable<MarketDashboard> {
    const query = `
            query($name: String!) {
                ${MarketDashboardDataService.entityName}GetByName(name: $name) {
                    ${MarketDashboardDataService.dashboardGetParams}
                }
            }
        `;

    return this.graphqlService.query<MarketDashboard>(query, { name });
  }

  getById$(id: ID): Observable<MarketDashboard> {
    const query = `
            query($id: Int!) {
                ${MarketDashboardDataService.entityName}GetById(id: $id) {
                    ${MarketDashboardDataService.dashboardGetParams}
                }
            }
        `;

    return this.graphqlService.query<MarketDashboard>(query, { id });
  }

  add$(input: MarketDashboard): Observable<MarketDashboard> {
    const mutation = `
            mutation ($input: DashboardInput!) {
                ${MarketDashboardDataService.entityName}Add(input: $input)
                {
                    ${MarketDashboardDataService.dashboardGetParams}
                }
            }
        `;

    const variables = {
      input,
    };

    return this.graphqlService.mutation<MarketDashboard>(mutation, variables);
  }

  update$(input: MarketDashboard): Observable<MarketDashboard> {
    const mutation = `
            mutation ($input: DashboardInput!) {
                ${MarketDashboardDataService.entityName}Update(input: $input)
                {
                    ${MarketDashboardDataService.dashboardGetParams}
                }
            }
        `;

    const variables = {
      input,
    };

    return this.graphqlService.mutation<MarketDashboard>(mutation, variables);
  }

  delete$(_id: ID): Observable<boolean> {
    throw new Error('Method not implemented.');
  }
}
